import React from 'react';
import { Modal } from 'react-responsive-modal';
import { Box, Grid, Typography } from '@mui/material';
import { MasterMessage } from '../../../../masters/masterMessages';
import ButtonGeneral from '../../../components/general/buttons/buttonGeneral';
import Save from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import FieldText from '../../../components/general/fields/fieldText';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import MultipleAutocompleteField from '../../../components/general/fields/multipleAutocompleteField';
import { asyncPostConfigWeCallYou } from '../../../../services/weCallYouAdmin.service';
import { SwalCustomClass } from '../../../components/general/toastSwal/swalCustomClass';
import { weekays } from './weekays';

type Props = {
    open: boolean;
    maxDates?: string | undefined;
    days?: any[];
    onClose: (value: boolean) => void;
    onSave: (value: boolean) => void;
};

const ModalConfigWeCallYou = ({
    open,
    maxDates,
    days,
    onClose,
    onSave,
}: Props) => {
    const { modalConfigWeCallYou }: any = MasterMessage.weCallYouAdmin;

    const formik = useFormik({
        initialValues: {
            maxDates: maxDates || '',
            days: days || [],
        },
        validationSchema: Yup.object({
            maxDates: Yup.number()
                .min(1, 'El número debe ser mayor a 0')
                .typeError('El número de días debe ser un número')
                .required('El número de días es obligatorio'),
            days: Yup.array(
                Yup.object({
                    id: Yup.string(),
                    name: Yup.string(),
                })
            )
                .min(1, 'Es obligatorio al menos un día de la semana')
                .required('Debes volver a seleccionar')
                .nullable(),
        }),
        onSubmit: async (formModalConfigWeCallYou) => {
            let newArray: any = [];
            formModalConfigWeCallYou.days.map(
                (item) => (newArray = newArray.concat(item.id))
            );
            formModalConfigWeCallYou.days = newArray;
            const body: any = await asyncPostConfigWeCallYou(
                formModalConfigWeCallYou
            );
            if (body?.items !== undefined) {
                onClose(false);
                onSave(true);
                formik.handleReset;
                SwalCustomClass.fire({
                    text: modalConfigWeCallYou.messageNew,
                    icon: 'success',
                    iconColor: '#1d1d1d',
                });
            } else {
                SwalCustomClass.fire({
                    text: modalConfigWeCallYou[body.message],
                    icon: 'success',
                    iconColor: '#1d1d1d',
                });
            }
        },
    });

    return (
        <Modal
            open={open}
            onClose={() => onClose(false)}
            closeOnOverlayClick={false}
            styles={{ modal: { maxWidth: '500px', minWidth: '40%' } }}
        >
            <Box>
                <Typography
                    color="primary"
                    component="h3"
                    sx={{
                        fontSize: { lg: 27, xs: 23 },
                        mt: { xs: 1.5, sm: 1.5, md: 1.5, lg: 0 },
                    }}
                >
                    {days && maxDates
                        ? modalConfigWeCallYou.titleEdit
                        : modalConfigWeCallYou.titleNew}
                </Typography>
                <hr />
                <Box mt={3} px={1}>
                    <Grid
                        container
                        spacing={{ xs: 2, md: 2 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                    >
                        <Grid item xs={12}>
                            <FieldText
                                label="Numero de dias disponibles"
                                name="maxDates"
                                size="small"
                                required={true}
                                touched={formik.touched.maxDates}
                                errors={formik.errors.maxDates}
                                value={formik.values.maxDates}
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MultipleAutocompleteField
                                data={weekays}
                                label="Seleccione los dias de la semana disponibles"
                                name="days"
                                size="small"
                                touched={formik.touched.days}
                                errors={formik.errors.days}
                                value={formik.values.days}
                                onChangeValue={(value) =>
                                    formik.setFieldValue('days', value)
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ textAlign: 'right' }}>
                            <ButtonGeneral
                                onClick={formik.handleSubmit}
                                startIcon={<Save color="secondary" />}
                                title="Guardar"
                                sx={{ mr: 1 }}
                            />
                            <ButtonGeneral
                                onClick={() => onClose(false)}
                                startIcon={<CancelIcon color="secondary" />}
                                title="Cancelar"
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Modal>
    );
};

export default ModalConfigWeCallYou;
